import React from 'react'
import { NavLink as ReactRouterNavLink } from 'react-router-dom'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import styles from './Tabs.scss'

export default function Tabs(props) {
  const {
    withBorders = false,
    renderTitle = title => title,
    tabs = [],
    currentTab,
    setCurrentTab = () => {},
    tabHeight,
    children: renderTab = () => {},
    tabClassName,
  } = props

  return (
    <div className={cx(styles.container, { [styles.withBorders]: withBorders })}>
      <Nav tabs>
        {tabs.map((tab, index) => {
          const tag = tab.to ? ReactRouterNavLink : undefined

          return (
            <NavItem key={index}>
              <NavLink
                tag={tag}
                tabIndex={2}
                onClick={() => setCurrentTab(index)}
                to={tab.to}
                className={cx({ active: currentTab === index })}
              >
                {renderTitle(tab, currentTab === index)}
              </NavLink>
            </NavItem>
          )
        })}
      </Nav>
      <TabContent activeTab={currentTab} className={tabClassName}>
        {tabs.map((tab, tabId) => (
          <TabPane key={tabId} tabId={tabId} style={{ height: tabHeight, overflowY: 'auto' }}>
            {renderTab(tab)}
          </TabPane>
        ))}
      </TabContent>
    </div>
  )
}

Tabs.propTypes = {
  withBorders: PropTypes.bool,
  tabs: PropTypes.arrayOf(PropTypes.object),
  renderTitle: PropTypes.func,
  currentTab: PropTypes.number.isRequired,
  setCurrentTab: PropTypes.func,
  children: PropTypes.any,
  tabHeight: PropTypes.number,
  tabClassName: PropTypes.string,
}
